module.exports = __webpack_public_path__ + "static/img/gmap-location.1bf93f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gmap-location.png
// module id = rLSj
// module chunks = 2